import { call, put } from 'redux-saga/effects';

import { EMPTY_OFFER } from 'connect/constants';
import { extractErrorMessage, sendToLogger } from 'connect/saga/helpers';
import request, { GET } from 'utils/request';

import { SagaHandler } from '../SagaHandler';

const DEFAULT_PROMOTION = {
  displayName: '$50 Prepaid VISA Card',
  giftCardType: 'VISA',
  referrerValue: 50,
  referralValue: 50,
};

const apiGetEligibleReferralPromotion = (referralCode) =>
  request(GET, `${CONFIG.API_URL}/referralPromotion/eligible/${referralCode}`);

const apiGetReferralPromotion = (referralPromoId) =>
  request(GET, `${CONFIG.API_URL}/referralPromotion/${referralPromoId}`);

class _RequestReferralPromotion extends SagaHandler {
  constructor() {
    super({
      actionName: 'data/REQUEST_REFFERAL_PROMOTION',
      stateKey: 'requestReferralPromotion',
      legacyOptions: {
        valueStateKey: 'promotion',
      },
      dependencies: ['data/REQUEST_OFFER'],
    });
  }

  /**
   * @param {object} action
   * @param {{ referralCode?: string, referralPromoId?: string }} action.payload
   *   A referral code, and/or the id of the promotion itself (the dm_referral_promo
   *   URL param).
   */
  * saga({ payload }) {
    const { referralCode, referralPromoId } = payload || {};

    const errorHandler = this.error;
    const loadingHandler = this.loading;
    const valueHandler = this.value;

    if (!referralCode && !referralPromoId) {
      return;
    }

    // A promotion id points at the promotion itself, so it takes precedence over the
    // referral code, which needs to be resolved to a promotion the referee is eligible for.
    const { apiGetPromotion, identifier } = (() => {
      if (referralPromoId) {
        return {
          apiGetPromotion: apiGetReferralPromotion,
          identifier: referralPromoId,
        };
      }

      return {
        apiGetPromotion: apiGetEligibleReferralPromotion,
        identifier: referralCode,
      };
    })();

    try {
      yield put(loadingHandler.update(true));
      yield put(errorHandler.update(null));

      const promotion = yield call(apiGetPromotion, identifier);

      yield put(valueHandler.update(promotion || DEFAULT_PROMOTION));

      const requestOffer = this._dependencies.data.REQUEST_OFFER;
      yield put(requestOffer.value.update(EMPTY_OFFER));
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      sendToLogger(error, 'requestReferralPromotion');
      yield put(errorHandler.update(errorMessage));
    } finally {
      yield put(loadingHandler.update(false));
    }
  }
}

export const RequestReferralPromotion = new _RequestReferralPromotion();
